import "../css/App.css"

function Footer() {
    return (
        <>
            <nav class="navbar navbar-expand-sm footer">

                <div class="container-fluid">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a class="nav-link a contorno" href='Mailto:yourny.oficial+contacto@gmail.com'>
                                <i class="bi bi-envelope mx-2"></i>
                                Contacto
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link a contorno" href='/sobreNosotros'>
                            <i class="bi bi-people mx-2"></i>
                            Sobre nosotros...</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link a contorno" href='/TyC'>
                                <i class="bi bi-file-earmark mx-2"></i>
                                Términos y condiciones
                            </a>
                        </li>
                    </ul>
                </div>

            </nav>
        </>
    );
}

export default Footer;